module.exports = __webpack_public_path__ + "img/22.a8697eba.jpeg";